import { Component, OnInit, Input, ViewChild, OnChanges, SimpleChanges } from '@angular/core';
import { NgForm } from '@angular/forms';
import { Constants } from '../../constants/constants';
import { ApiService } from '../../service/api.service';
import { AuthenticationService } from '../../service/authentication.service';
import { UtilService } from '../../service/util.service';
import { ToastService } from '../../service/toast.service';
import { AddTcuDeviceComponent } from '../../tcu-detail/add-tcu-device/add-tcu-device.component';
import { DeviceService } from 'src/app/service/device.service';

@Component({
  selector: 'app-device-summary',
  templateUrl: './device-summary.component.html',
  styleUrls: ['./device-summary.component.scss']
})
export class DeviceSummaryComponent implements OnInit, OnChanges {


  deviceData;
  @Input() inDeviceData;
  // @Input() deviceId;
  // @Input() isShowDeviceDetailsHeader = true;
  noVehicleDeviceMessage = Constants.NO_VEHICLE_DEVICE_MESSAGE;

  selectedDevice = null;
  isDeviceUpdateClicked = false;

  // @ViewChild('addTcuDevice', { static: true }) public addTcuDevice: AddTcuDeviceComponent;
  tcuDevice: any;

  constructor(private apiService: ApiService, public authService: AuthenticationService, private utilService: UtilService, private toastService: ToastService, private deviceService: DeviceService) { }

  ngOnChanges(changes: SimpleChanges): void {
    // console.log("this.isShowDeviceDetailsHeader : ", this.isShowDeviceDetailsHeader);
    // this.getDeviceDetails(this.deviceId);
    /* if (this.selectedVehicle) {
      this.initTcuDevices(this.selectedVehicle.devices);
    } */

    // this.getDeviceDetails('ACCM8fb914115dbb479c');


    if (this.inDeviceData) {
      //  this.initTcuDevices(this.deviceData);
      this.deviceData = this.inDeviceData;
      //  this.getDeviceDetails(this.deviceData.id);
    }
  }

  ngOnInit() {
    // console.log("this.isShowDeviceDetailsHeader : ", this.isShowDeviceDetailsHeader);

    // this.initTcuDevices(this.vehicleData.devices);
    // this.initTcuDevices(this.selectedVehicle);

    // if (this.vehicleData.devices) {
    //   this.tcuDevices = this.vehicleData.devices;
    // }

    // console.log("TCU devices : ", this.tcuDevices);

  }

  /* initTcuDevices(devices) {
    if (devices && devices.length > 0) {
      this.tcuDevices = devices;
    } else {
      if (this.selectedVehicle.enrollmentEligibility) {
        this.tcuDevices = [
          {
            "type": "TCU_DEVICE",
            "model": "A-IVC",
            "telematicsType": "EMBEDDED",
            "telematicsProvider": "Kamereon"
          }
        ]
      } else if (this.selectedVehicle.telematicsAvailability) {
        this.tcuDevices = [
          {
            "type": "TCU_DEVICE",
            "model": "TCU2K",
            "telematicsType": "EMBEDDED",
            "telematicsProvider": "SXM"
          }
        ]
      }
    }

    console.log("TCU devices : ", this.tcuDevices);
  } */
  /* initTcuDevices(device) {
    if (device) {
      this.tcuDevice= device;
    }

    console.log("TCU devices : ", this.tcuDevices);
  } */

  /* getVehicleDetail() {
    this.utilService.showSpinner();
    this.apiService.getVehicleDetails(this.deviceData.vin).then((data) => {
      this.utilService.hideSpinner();
      console.log("Get vehicle detail from api : ", data);
      this.isDeviceUpdateClicked = false;
    }).catch((error) => {
      console.log("err : ", error);
      if (error.status == Constants.HTTP_UNAUTHORISED) {
        this.authService.refreshToken().then(() => {
          this.utilService.hideSpinner();
          console.log("refresh token api executed");
          this.getVehicleDetail();
        });
      }
      else {
        this.utilService.hideSpinner();
        if (error && error.error && error.error.message) this.toastService.showError(error.error.message);
        else this.toastService.showError(Constants.UNKNOWN_ERROR);
      }
    });
  } */

  editDevice(index) {
    this.isDeviceUpdateClicked = true;
    console.log("Edit device at index : ", index);
    //--> Incoming changes
    // this.selectedDevice = JSON.parse(JSON.stringify(this.tcuDevices[index]));
    // this.addTcuDevice.editDevice(this.isDeviceUpdateClicked, this.selectedDevice);
    // this.vehicleDevice.type = this.selectedDevice.type;
    // this.vehicleDevice.telematicsType = this.selectedDevice.telematicsType;
    // this.vehicleDevice.telematicsProvider = this.selectedDevice.telematicsProvider;
    // this.vehicleDevice.manufacturer = this.selectedDevice.manufacturer;
    // this.vehicleDevice.model = this.selectedDevice.model;
    // this.vehicleDevice.imeiId = this.selectedDevice.imeiId;
    // this.vehicleDevice.simId = this.selectedDevice.simId;
    // this.vehicleDevice.msisdn = this.selectedDevice.msisdn;
    // this.vehicleDevice.firmwareVersion = this.selectedDevice.firmwareVersion;

    // this.handleDeviceTypeChange(this.vehicleDevice.type);
    // document.getElementById("openAddVehicleDevice").click();
    //<-- Incoming changes
    //***********************************/
    //--> Develop changes
    /* this.selectedDevice = JSON.parse(JSON.stringify(this.tcuDevices[index]));

    this.vehicleDevice.telematicsType = this.selectedDevice.telematicsType;
    this.vehicleDevice.telematicsProvider = this.selectedDevice.telematicsProvider;
    this.vehicleDevice.tcuManufacturer = this.selectedDevice.tcuManufacturer;
    this.vehicleDevice.tcuType = this.selectedDevice.tcuType;
    this.vehicleDevice.imeiId = this.selectedDevice.imeiId;
    this.vehicleDevice.simId = this.selectedDevice.simId;
    this.vehicleDevice.msisdn = this.selectedDevice.msisdn;

    document.getElementById("openTcuDataModal").click(); */
    //<-- Develop changes
  }

  // deleteDevice(index) {
  // console.log("Delete device at index : ", index);
  // //--> Incoming changes
  // if (this.tcuDevices.length == 1)
  //   this.toastService.showError(Constants.MINIMUM_DEVICE_ERROR);
  // else {
  //   // this.selectedDevice = JSON.parse(JSON.stringify(this.tcuDevices[index]));
  //   document.getElementById("openConfirmation").click();
  // }
  //<-- Incoming changes
  //--> Develop changes
  /* this.selectedDevice = JSON.parse(JSON.stringify(this.tcuDevices[index]));
  document.getElementById("openConfirmation").click(); */
  //<-- Develop changes
  // }

  /* cancelDeleteDevice() {
    this.selectedDevice = {};
  } */

  /*  onConfirmDeleteDevice() {
     this.deleteAccountVehicleDevice();
   } */

  /* deleteAccountVehicleDevice() {
    this.utilService.showSpinner();
    this.apiService.deleteVehicleDevice(this.deviceData.vin, this.selectedDevice.id).then((data) => {
      this.utilService.hideSpinner();
      console.log("delete vehicle device response ::", data);
      this.toastService.showSuccess("Device deleted successfully");
      this.getVehicleDetail();
    }).catch((error) => {
      console.log("err : ", error);
      if (error.status == Constants.HTTP_UNAUTHORISED) {
        this.authService.refreshToken().then(() => {
          this.utilService.hideSpinner();
          console.log("refresh token api executed");
          this.deleteAccountVehicleDevice();
        });
      }
      else {
        this.utilService.hideSpinner();
        if (error && error.error && error.error.message) this.toastService.showError(error.error.message);
        else this.toastService.showError(Constants.UNKNOWN_ERROR);
      }
    });
  } */

  getDeviceLogo(device): string {
    return this.deviceService.getDeviceLogo(device);
  }

  onVehicleDeviceUnlink(data) {

    //create get device by device id and call
    this.getDeviceDetails(this.deviceData.id);
    // this.getDeviceDetails(this.deviceId);
  }

  getDeviceDetails(deviceId) {
    this.utilService.showSpinner();
    this.apiService.getDeviceDetails(deviceId).then((data) => {
      this.utilService.hideSpinner();
      console.log("device details response::", data);
      this.deviceData = data;
    }).catch((error) => {
      console.log("err : ", error);
      if (error.status == Constants.HTTP_UNAUTHORISED) {
        this.authService.refreshToken().then(() => {
          this.utilService.hideSpinner();
          console.log("refresh token api executed");
          this.getDeviceDetails(deviceId);
        });
      }
      else {
        this.utilService.hideSpinner();
        if (error && error.error && error.error.message) this.toastService.showError(error.error.message);
        else this.toastService.showError(Constants.UNKNOWN_ERROR);
      }
    });
  }

  updateDeviceData(data) {
    // this.deviceData.dongleStatus = data.responseData.dongleStatus;
    this.deviceData = data.responseData;

  }
}